export class ReplayLock {
    #leaseMs;
    #now;
    #leases = new Map();
    constructor(options = {}) {
        this.#leaseMs = options.leaseMs ?? 30_000;
        if (!Number.isInteger(this.#leaseMs) || this.#leaseMs <= 0)
            throw new RangeError("Replay lease must be positive");
        this.#now = options.now ?? (() => new Date().toISOString());
    }
    acquire(domain, intentId) {
        const now = this.#now();
        const current = this.#leases.get(domain);
        if (current !== undefined && Date.parse(current.expiresAt) > Date.parse(now))
            return undefined;
        const lease = {
            domain,
            expiresAt: new Date(Date.parse(now) + this.#leaseMs).toISOString(),
            intentId,
            token: Symbol(`${domain}:${intentId}`),
        };
        this.#leases.set(domain, lease);
        return lease;
    }
    recoverExpired(now = this.#now()) {
        const recovered = [];
        for (const [domain, lease] of this.#leases) {
            if (Date.parse(lease.expiresAt) <= Date.parse(now)) {
                this.#leases.delete(domain);
                recovered.push(domain);
                break;
            }
        }
        return recovered;
    }
    release(domain, token) {
        const current = this.#leases.get(domain);
        if (current === undefined || current.token !== token)
            return false;
        this.#leases.delete(domain);
        return true;
    }
}
//# sourceMappingURL=replay-lock.js.map